import { gql } from "@apollo/client";

export const GET_PRORROGAS = gql`
query GetProrrogas($idDelegacion: Int!) {
    prorrogas(idDelegacion: $idDelegacion)
    {
        success,
        error,
        valorEsperado {
          idEvaluacion,
          nombre,
          apellido,
          razonSocial,
          planCuidado,
          precioDiario,
          fechaDesde,
          fechaHasta,
          vencimiento,
          idEstadoPaciente,
          descripcionEstadoPaciente,
          precioSAP,
          bloqueoSAP,
          planCuidadoActivo,
          idPlanCuidadoEstado,
          idResultadoPresupuesto,
          cotizado,
          idCliente,
          estadoPrecio,
          idTipoModulo
        }
    }
}`;